<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Performance Index
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" xs="12" sm="3" lg="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="academicyear" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="3" lg="3" md="3">
                 <v-btn class="button mt-none pt-none" small v-if="instructor && academicyear" @click="getIndex();show=true">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" dense v-if="show">
                 <v-data-table :headers="headers" :items="performance_index_list" class="elevation-1 mytable" dense :search="search">
                 </v-data-table>
                <!-- {{performance_index_list}}
                {{total_stud_count}} -->
                <center><strong>Total Student</strong> :: {{total_stud_count}} </center>
                <center><strong>Cummulative Performance Index </strong> :: {{commuluative}} % </center>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            color: "",
            aylist: [],
            instructor_list: [],
            instructor: "",
            academicyear: "",
            performance_index_list:[],
            total_stud_count:null,
            show:false,
            commuluative:null,
             headers: [
                {
                    text: "Sr. No.",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Feedback Version",
                    sortable: false,
                    value: "feedback_no",
                },
                {
                    text: "Number Of Students",
                    sortable: false,
                    value: "no_stud",
                },
                {
                    text: "Performance Index %",
                    sortable: false,
                    value: "performance_index",
                },
               
            ],
        }),
        methods: {
            getIndex(){
                const data={
                    instructor:this.instructor,
                    academicyear:this.academicyear
                }
                 axios
                    .post("/Feedback/getIndex",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.performance_index_list = res.data.performance_index_list
                            this.total_stud_count = res.data.total_stud_count
                            this.commuluative = res.data.commuluative
                        } else if (res.data.flag == "NO")  {
                             this.showSnackbar("#b71c1c", res.data.status);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {});
            },
            onLoad() {
                axios
                    .post("/Feedback/getData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.aylist = res.data.aylist;
                            this.instructor_list = res.data.instructor_list;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
    };
</script>

<style scoped>
.mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
